import { createContext } from "react";

export const ModalElementContext = createContext({
  onClose: () => {},
  targetTripId: "",
  isResultsModal: false,
  dispatchLocalState: () => {},
  resultsSFData: {}
});
